// extracted by mini-css-extract-plugin
export var chip = "_4k-0";
export var filterDropdown = "_4k-5";
export var filterItem = "_4k-6";
export var icon = "_4k-1";
export var removeButton = "_4k-3";
export var removeIcon = "_4k-4";
export var separator = "_4k-2";